import React from 'react'

import * as moment from 'moment';

import MarkdownPreview from '@uiw/react-markdown-preview';

import { SVGIcon } from '../../wrappers/SVGIcon';

import { Icons } from '../../../data/Assets';
import { EExpertChatSource, IExpertChat } from '../../../interfaces/expert_chats';

interface IChatProps {
    expert_chat: IExpertChat;
};

const Chat = (props: IChatProps) => {
    const { expert_chat } = props;

    const { source, message, created_at } = expert_chat;

    const chatClass = source === EExpertChatSource.EXPERT ? 'immersion__immigration_help__chat__sent' : '';

    return (
        <div className={`immersion__immigration_help__chat ${chatClass}`}>
            <div className='immersion__immigration_help__chat__avatar'>
                <SVGIcon src={Icons.UserCircleFill} color={source === EExpertChatSource.EXPERT ? 'primary' : 'grey'} />
            </div>
            <div className='immersion__immigration_help__chat__content'>
                <MarkdownPreview  source={message} className='immersion__immigration_help__chat__content__text' />
                <span className='immersion__immigration_help__chat__content__timestamp mice'>
                    {moment.utc(new Date(created_at)).format('HH:mm')}
                </span>
            </div>
        </div>
    )
}

export default Chat